/**
 * TealerLab — Fly to Cart : Hybrid (Product image + Trail particles + Final burst)
 *
 * Quand on ajoute au panier :
 *   1. Un GHOST de l'image produit vole en courbe Bezier vers le panier
 *      (scale dramatique 1 → 0.25, durée 950ms, jamais de rotation)
 *   2. Pendant le vol, un TRAIL de particules (🌿✨💨 + cercles lime) émane
 *      de la position courante du ghost (1 particule toutes les ~70ms)
 *   3. Au moment où le ghost atteint le panier → BURST FINAL : 8 particules
 *      jaillissent en éventail depuis le panier puis convergent vers le centre
 *   4. Panier : flash lime + vibre + bounce du badge
 *
 * Self-contained, vanilla JS, ~14K. Activer logs : `window.tlrFlyDebug = true`
 */
(function () {
  'use strict';

  const CFG = Object.assign({
    flyDuration: 950,            // durée du vol image
    arcHeightRatio: 0.55,        // hauteur de l'arc (% distance)
    trailInterval: 70,           // ms entre 2 particules trail
    finalParticles: 10,          // nombre de particules au burst final
    selectors: {
      buttons: '.tlr-pdpm__atc, .tlr-pgrid__atc, .tlr-coll__atc, .tlr-variety__atc, .tlr-fbt__add, .tlr-card__atc, .tlr-bento__add, [data-atc], [data-add-variant], [data-tlr-atc], [data-add-to-cart], button[name="add"], .product-form__submit',
      images: '.tlr-pgrid__media img, .tlr-coll__media img, .tlr-variety__media img, .tlr-pdpm__main-img, .tlr-pdpm__sticky-thumb, .tlr-fbt__media img, .tlr-bento__media img, .tlr-bundle__media img, .tlr-drop__media img, .tlr-card__img, .product-media img, img',
      cart: '.tlr-hdr-block--cart, [data-tlr-cart-icon], .tlr-cart-icon, [data-cart-icon-bubble], .header__icon--cart, header-component a[href*="/cart"], a[href="/cart"]',
      badge: '.tlr-hdr-badge, [data-cart-count], [data-tlr-cart-bubble], .cart-bubble, [data-cart-icon-count], .header__icon-counter, .tlr-cart-icon__count'
    }
  }, window.tlrFlyConfig || {});

  const DEBUG = window.tlrFlyDebug === true;
  const log = (...a) => DEBUG && console.log('[tlr-fly]', ...a);

  // Particules pool pour le trail + burst final
  const TRAIL_VARIANTS = [
    { type: 'emoji', char: '🌿', size: 22 },
    { type: 'emoji', char: '✨', size: 18 },
    { type: 'emoji', char: '💨', size: 20 },
    { type: 'shape', shape: 'circle', color: '#d8ff5a', size: 10 },
    { type: 'shape', shape: 'star',   color: '#ff6a13', size: 14 },
  ];

  if (!document.getElementById('tlr-fly-css')) {
    const style = document.createElement('style');
    style.id = 'tlr-fly-css';
    style.textContent = `
      .tlr-fly-host {
        position: fixed;
        z-index: 2147483647;
        pointer-events: none;
        top: 0; left: 0;
        width: 100vw; height: 100vh;
        overflow: visible;
      }
      .tlr-fly-ghost {
        position: absolute;
        will-change: transform, opacity;
        border-radius: 18px;
        overflow: hidden;
        background: #fff;
        box-shadow:
          0 12px 30px rgba(11,11,11,.25),
          0 4px 12px rgba(11,11,11,.15),
          0 0 0 3px rgba(216,255,90,.7),
          0 0 24px rgba(216,255,90,.5);
        backface-visibility: hidden;
      }
      .tlr-fly-ghost img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .tlr-fly-particle {
        position: absolute;
        will-change: transform, opacity;
        line-height: 1;
        text-align: center;
        user-select: none;
        backface-visibility: hidden;
      }
      .tlr-fly-particle.is-shape {
        border-radius: 50%;
      }
      .tlr-fly-particle.is-shape.shape-circle {
        box-shadow: 0 0 10px currentColor, 0 0 20px currentColor;
      }
      .tlr-fly-particle.is-shape.shape-star {
        clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
        border-radius: 0;
        filter: drop-shadow(0 0 6px currentColor);
      }
      @keyframes tlr-cart-flash-lime {
        0%   { box-shadow: 0 0 0 0 rgba(216,255,90, 0); }
        20%  { box-shadow: 0 0 0 8px rgba(216,255,90, .6), 0 0 30px 10px rgba(216,255,90, .8); }
        100% { box-shadow: 0 0 0 28px rgba(216,255,90, 0), 0 0 50px 20px rgba(216,255,90, 0); }
      }
      .tlr-cart-flash-lime {
        animation: tlr-cart-flash-lime 0.75s ease-out both;
        border-radius: 16px;
      }
      @keyframes tlr-cart-vibrate {
        0%, 100%  { transform: translate(0, 0) scale(1); }
        15%       { transform: translate(-3px, -2px) scale(1.08); }
        30%       { transform: translate(3px, -1px) scale(1.12); }
        45%       { transform: translate(-2px, 2px) scale(1.06); }
        60%       { transform: translate(2px, 1px) scale(1.1); }
        75%       { transform: translate(-1px, -1px) scale(1.04); }
      }
      .tlr-cart-vibrate {
        animation: tlr-cart-vibrate 0.55s cubic-bezier(.36, 1.5, .5, 1) both;
        transform-origin: center;
      }
      @keyframes tlr-cart-badge-bounce {
        0%   { transform: scale(1); }
        25%  { transform: scale(1.7); }
        55%  { transform: scale(0.85); }
        80%  { transform: scale(1.15); }
        100% { transform: scale(1); }
      }
      .tlr-cart-badge-bounce {
        animation: tlr-cart-badge-bounce 0.55s cubic-bezier(.34, 1.6, .5, 1) both;
      }
      /* Cart drawer slide-in/out fluide */
      #tlr-cart-drawer[open] {
        animation: tlr-drawer-slide-in 0.42s cubic-bezier(.22, .61, .36, 1) both;
      }
      #tlr-cart-drawer[open]::backdrop {
        animation: tlr-drawer-backdrop-in 0.32s ease-out both;
      }
      #tlr-cart-drawer[open].is-closing {
        animation: tlr-drawer-slide-out 0.32s cubic-bezier(0.55, 0.06, 0.68, 0.19) both;
      }
      #tlr-cart-drawer[open].is-closing::backdrop {
        animation: tlr-drawer-backdrop-out 0.28s ease-in both;
      }
      @keyframes tlr-drawer-slide-in {
        from { transform: translateX(100%); opacity: 0; }
        to   { transform: translateX(0); opacity: 1; }
      }
      @keyframes tlr-drawer-slide-out {
        from { transform: translateX(0); opacity: 1; }
        to   { transform: translateX(100%); opacity: 0; }
      }
      /* Desktop float: the drawer sits 12px off the edge — 100% alone leaves
         a sliver at both ends of the slide. Twin of the menu drawer's kit. */
      @keyframes tlr-drawer-slide-in-desk {
        from { transform: translateX(calc(100% + 12px)); opacity: 0; }
        to   { transform: translateX(0); opacity: 1; }
      }
      @keyframes tlr-drawer-slide-out-desk {
        from { transform: translateX(0); opacity: 1; }
        to   { transform: translateX(calc(100% + 12px)); opacity: 0; }
      }
      @media (min-width: 769px) {
        #tlr-cart-drawer[open] { animation-name: tlr-drawer-slide-in-desk; }
        #tlr-cart-drawer[open].is-closing { animation-name: tlr-drawer-slide-out-desk; }
      }
      @media (prefers-reduced-motion: reduce) {
        #tlr-cart-drawer[open],
        #tlr-cart-drawer[open].is-closing,
        #tlr-cart-drawer[open]::backdrop,
        #tlr-cart-drawer[open].is-closing::backdrop { animation: none !important; }
      }
      @keyframes tlr-drawer-backdrop-in {
        from { background: rgba(11,11,11,0); backdrop-filter: blur(0); -webkit-backdrop-filter: blur(0); }
        to   { background: rgba(11,11,11,.45); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
      }
      @keyframes tlr-drawer-backdrop-out {
        from { background: rgba(11,11,11,.45); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }
        to   { background: rgba(11,11,11,0); backdrop-filter: blur(0); -webkit-backdrop-filter: blur(0); }
      }
      @media (prefers-reduced-motion: reduce) {
        .tlr-fly-host { display: none !important; }
        .tlr-cart-flash-lime, .tlr-cart-vibrate, .tlr-cart-badge-bounce,
        #tlr-cart-drawer[open], #tlr-cart-drawer[open]::backdrop { animation: none !important; }
      }
    `;
    document.head.appendChild(style);
  }

  function findCartIcon() {
    const candidates = document.querySelectorAll(CFG.selectors.cart);
    for (const c of candidates) {
      const r = c.getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top >= 0 && r.top < window.innerHeight) return c;
    }
    return candidates[0] || null;
  }

  function findSourceImage(button) {
    const containers = [
      button.closest('article'),
      button.closest('.tlr-card'),
      button.closest('.tlr-pgrid__card'),
      button.closest('.tlr-coll__card'),
      button.closest('.tlr-variety__card'),
      button.closest('.tlr-pdpm'),
      button.closest('product-form-component'),
      button.closest('form'),
      button.closest('[data-product-card]'),
    ].filter(Boolean);

    for (const ctn of containers) {
      // Sliding gallery (PDP): the first <img> in DOM order is always slide 1 —
      // prefer the active slide so the ghost shows the photo actually on screen.
      const activeImg = ctn.querySelector('.swiper-slide-active img');
      if (activeImg && activeImg.complete && activeImg.naturalWidth > 0) return activeImg;
      const img = ctn.querySelector(CFG.selectors.images);
      if (img && img.complete && img.naturalWidth > 0) return img;
    }

    const all = document.querySelectorAll(CFG.selectors.images);
    const btnRect = button.getBoundingClientRect();
    let best = null, bestDist = Infinity;
    all.forEach(img => {
      if (!img.complete || img.naturalWidth === 0) return;
      const r = img.getBoundingClientRect();
      if (r.width < 60 || r.height < 60) return;
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const dx = (r.left + r.width/2) - (btnRect.left + btnRect.width/2);
      const dy = (r.top + r.height/2) - (btnRect.top + btnRect.height/2);
      const d = Math.hypot(dx, dy);
      if (d < bestDist) { bestDist = d; best = img; }
    });
    return best;
  }

  function easeInOut(t) { return t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2; }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function bezier(t, p0, p1, p2, p3) {
    const u = 1 - t;
    return u*u*u*p0 + 3*u*u*t*p1 + 3*u*t*t*p2 + t*t*t*p3;
  }

  function makeParticle(host, x, y, variant, sizeMult = 1) {
    const el = document.createElement('div');
    if (variant.type === 'emoji') {
      el.className = 'tlr-fly-particle is-emoji';
      el.textContent = variant.char;
      el.style.fontSize = (variant.size * sizeMult) + 'px';
    } else {
      el.className = `tlr-fly-particle is-shape shape-${variant.shape}`;
      const s = variant.size * sizeMult;
      el.style.width = s + 'px';
      el.style.height = s + 'px';
      el.style.background = variant.color;
      el.style.color = variant.color;
    }
    el.style.left = x + 'px';
    el.style.top = y + 'px';
    el.style.transform = 'translate(-50%, -50%) scale(0)';
    host.appendChild(el);
    return el;
  }

  function animateTrailParticle(el, fromX, fromY) {
    // Petit float-up + fade away
    const angle = (Math.random() - 0.5) * Math.PI; // direction random
    const dist = lerp(20, 60, Math.random());
    const dx = Math.cos(angle) * dist;
    const dy = Math.sin(angle) * dist - 30; // bias upward
    const rot = (Math.random() - 0.5) * 240;
    el.animate([
      { transform: 'translate(-50%, -50%) scale(0) rotate(0deg)', opacity: 0 },
      { transform: `translate(-50%, -50%) translate(${dx*0.3}px, ${dy*0.3}px) scale(1.1) rotate(${rot*0.4}deg)`, opacity: 1, offset: 0.3 },
      { transform: `translate(-50%, -50%) translate(${dx}px, ${dy}px) scale(0.6) rotate(${rot}deg)`, opacity: 0 }
    ], { duration: 700, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'forwards' })
    .onfinish = () => el.remove();
  }

  function finalBurst(host, x, y) {
    // 10 particules qui jaillissent depuis le panier en éventail
    for (let i = 0; i < CFG.finalParticles; i++) {
      const variant = TRAIL_VARIANTS[i % TRAIL_VARIANTS.length];
      const el = makeParticle(host, x, y, variant, lerp(0.9, 1.3, Math.random()));
      const angle = (i / CFG.finalParticles) * Math.PI * 2 + (Math.random() - 0.5) * 0.5;
      const dist = lerp(60, 110, Math.random());
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist;
      const rot = (Math.random() - 0.5) * 360;
      el.animate([
        { transform: 'translate(-50%, -50%) scale(0)', opacity: 0 },
        { transform: `translate(-50%, -50%) translate(${dx*0.6}px, ${dy*0.6}px) scale(1.3) rotate(${rot*0.5}deg)`, opacity: 1, offset: 0.4 },
        { transform: `translate(-50%, -50%) translate(${dx}px, ${dy}px) scale(0.4) rotate(${rot}deg)`, opacity: 0 }
      ], { duration: 600, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'forwards' })
      .onfinish = () => el.remove();
    }
  }

  /**
   * Animation principale : image produit vole en arc + trail particules + burst final
   */
  function flyAnimation(srcImg, dest) {
    if (!srcImg || !dest) return Promise.resolve();
    const sr = srcImg.getBoundingClientRect();
    const dr = dest.getBoundingClientRect();

    const startX = sr.left + sr.width / 2;
    const startY = sr.top + sr.height / 2;
    const endX = dr.left + dr.width / 2;
    const endY = dr.top + dr.height / 2;

    const dx = endX - startX;
    const dy = endY - startY;
    const dist = Math.hypot(dx, dy);
    const arc = Math.max(180, dist * CFG.arcHeightRatio);

    // Bezier cubique : P0=(0,0), P1, P2, P3=(dx, dy)
    const p1x = dx * 0.2, p1y = -arc;
    const p2x = dx * 0.7, p2y = dy * 0.4 - arc * 0.5;
    const p3x = dx,       p3y = dy;

    log('fly start', {startX, startY}, '→', {endX, endY}, 'arc:', arc);

    // Container fixed pour particules + ghost
    const host = document.createElement('div');
    host.className = 'tlr-fly-host';
    document.body.appendChild(host);

    const ghostSize = Math.min(160, Math.max(90, Math.min(sr.width, sr.height) * 0.55));
    const ghost = document.createElement('div');
    ghost.className = 'tlr-fly-ghost';
    ghost.style.left = (startX - ghostSize / 2) + 'px';
    ghost.style.top = (startY - ghostSize / 2) + 'px';
    ghost.style.width = ghostSize + 'px';
    ghost.style.height = ghostSize + 'px';
    ghost.style.opacity = '0';
    ghost.style.transform = 'translate3d(0, 0, 0) scale(0.6)';
    const ghostImg = document.createElement('img');
    ghostImg.src = srcImg.currentSrc || srcImg.src;
    ghostImg.alt = '';
    ghost.appendChild(ghostImg);
    host.appendChild(ghost);

    return new Promise(resolve => {
      const t0 = performance.now();
      let lastTrailAt = 0;

      function tick(now) {
        const elapsed = now - t0;
        const tRaw = Math.min(1, elapsed / CFG.flyDuration);
        const t = easeInOut(tRaw);

        // Position le long de la courbe Bezier
        const x = bezier(t, 0, p1x, p2x, p3x);
        const y = bezier(t, 0, p1y, p2y, p3y);

        let scale, opacity;
        if (tRaw < 0.12) {
          const tp = tRaw / 0.12;
          scale = lerp(0.6, 1, tp);
          opacity = tp;
        } else if (tRaw < 0.9) {
          const tp = (tRaw - 0.12) / 0.78;
          scale = lerp(1, 0.4, tp);
          opacity = 1;
        } else {
          const tp = (tRaw - 0.9) / 0.1;
          scale = lerp(0.4, 0.2, tp);
          opacity = 1 - tp;
        }

        // Pas de rotation sur le pochon : c'est l'accusé de réception de l'ajout
        // au panier, il reste droit. Le vol, l'échelle et l'opacité portent le
        // feedback.
        ghost.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
        ghost.style.opacity = opacity;

        if (elapsed - lastTrailAt > CFG.trailInterval && tRaw > 0.05 && tRaw < 0.85) {
          lastTrailAt = elapsed;
          const variant = TRAIL_VARIANTS[Math.floor(Math.random() * TRAIL_VARIANTS.length)];
          // Émet la particule au CENTRE actuel du ghost
          const px = startX + x;
          const py = startY + y;
          const trailEl = makeParticle(host, px, py, variant, lerp(0.8, 1.1, Math.random()));
          animateTrailParticle(trailEl, px, py);
        }

        if (tRaw < 1) {
          requestAnimationFrame(tick);
        } else {
          // Fin du vol : burst final + cleanup
          finalBurst(host, endX, endY);
          ghost.remove();
          pulseCart(dest);
          // Cleanup host après que toutes particules trail+final soient parties
          setTimeout(() => host.remove(), 800);
          document.dispatchEvent(new CustomEvent('tlr:fly:complete'));
          resolve();
        }
      }
      requestAnimationFrame(tick);
    });
  }

  function pulseCart(dest) {
    if (!dest) return;
    dest.classList.remove('tlr-cart-flash-lime');
    void dest.offsetWidth;
    dest.classList.add('tlr-cart-flash-lime');
    setTimeout(() => dest.classList.remove('tlr-cart-flash-lime'), 800);

    const target = dest.querySelector('.tlr-hdr-icon-svg, .tlr-hdr-icon, svg, .icon, .tlr-cart-icon__svg') || dest;
    target.classList.remove('tlr-cart-vibrate');
    void target.offsetWidth;
    target.classList.add('tlr-cart-vibrate');
    setTimeout(() => target.classList.remove('tlr-cart-vibrate'), 600);

    const badge = dest.querySelector(CFG.selectors.badge);
    if (badge) {
      badge.classList.remove('tlr-cart-badge-bounce');
      void badge.offsetWidth;
      badge.classList.add('tlr-cart-badge-bounce');
      setTimeout(() => badge.classList.remove('tlr-cart-badge-bounce'), 600);
    }
  }

  window._tlrFlyAnimating = false;
  let _lastClickedImg = null;
  let _lastClickAt = 0;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(CFG.selectors.buttons);
    if (!btn) return;
    if (btn.disabled) return;
    if (btn.closest('#tlr-cart-drawer')) return;
    if (btn.closest('[data-tlr-cart-items]')) return;

    log('ATC click intercepted', btn);
    const srcImg = findSourceImage(btn);
    const dest = findCartIcon();
    log('source:', srcImg, '→ dest:', dest);

    if (srcImg && dest) {
      _lastClickedImg = srcImg;
      _lastClickAt = Date.now();
      window._tlrFlyAnimating = true;
      requestAnimationFrame(() => {
        flyAnimation(srcImg, dest).then(() => {
          window._tlrFlyAnimating = false;
        });
      });
    }
  }, true);

  document.addEventListener('click', (e) => {
    const img = e.target.closest('img');
    if (img && img.complete && img.naturalWidth > 80) _lastClickedImg = img;
  }, true);

  let _lastCount = -1;
  document.addEventListener('cart:updated', () => {
    fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(c => {
      if (_lastCount !== -1 && c.item_count > _lastCount) {
        const recentClick = Date.now() - _lastClickAt < 1500;
        if (!recentClick) {
          const dest = findCartIcon();
          if (dest && _lastClickedImg) {
            window._tlrFlyAnimating = true;
            flyAnimation(_lastClickedImg, dest).then(() => {
              window._tlrFlyAnimating = false;
            });
          } else if (dest) {
            pulseCart(dest);
          }
        }
      }
      _lastCount = c.item_count;
    }).catch(() => {});
  });

  fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(c => {
    _lastCount = c.item_count || 0;
  }).catch(() => {});

  window.tlrFlyToCart = { fly: flyAnimation, pulse: pulseCart };
})();
